import { useMemo } from 'react';
import { useEventsQuery } from 'features/events';
import { useCalendarPrincipalEventsQuery } from '../../../../queries';
import type { Mode } from '../../../../types';
import { useCreateCalendarEvents } from './useCreateCalendarEvents';
import { useGetParamsForCalendarPrincipalEventsQuery } from './useGetParamsForCalendarPrincipalEventsQuery';
import { useGetParamsForEventsQuery } from './useGetParamsForEventsQuery';

export const useGetCalendarEvents = ({ date, mode }: { date: Date; mode: Mode }) => {
  const getParamsForEventsQuery = useGetParamsForEventsQuery();
  const createCalendarEvents = useCreateCalendarEvents();
  const getParamsForCalendarPrincipalEventsQuery = useGetParamsForCalendarPrincipalEventsQuery();

  const { data: events, isFetching: isFetchingEvents } = useEventsQuery(getParamsForEventsQuery({ date, mode }));
  const { data: nodeEvents, isFetching: isFetchingNodeEvents } = useCalendarPrincipalEventsQuery(
    getParamsForCalendarPrincipalEventsQuery({ date, mode }),
  );

  const calendarEvents = useMemo(() => {
    if (!nodeEvents || !events) {
      return undefined;
    }

    return createCalendarEvents({ nodeEvents, railsEvents: events });
  }, [createCalendarEvents, events, nodeEvents]);

  return useMemo(
    () => ({
      events: calendarEvents,
      isFetching: isFetchingEvents || isFetchingNodeEvents,
    }),
    [calendarEvents, isFetchingEvents, isFetchingNodeEvents],
  );
};
